export const trackGAEvent = (
  eventName: string,
  params?: Record<string, string>
) => {
  if (typeof window.gtag !== 'undefined') {
    console.log("gtag")
    window.gtag('event', eventName, params);
  }
};

export enum EVENT {
  BTN_COPY_LINK = 'btn_copy_shared_link',
  BTN_SHARE_CLICKED = 'btn_share_clicked',
  VISIT_SHARE_NAV_PAGE = 'visit_share_nav_page',
  NAV_PAGE_3D_INTERACTION = 'nav_page_3d_interaction',
  EXPLORE_JOYSTICK_INTERACTION = 'explore_joystick_interaction',
  EXPLORE_INTERACTION = 'explore_interaction',
}


export enum AMPLITUDE_EVENT {
  SHARE_INTENT_STARTED = 'share_intent_started',        // user clicked on share button
  COPY_SHARE_LINK_CLICKED = 'copy_share_link_clicked',  // user copied the shared link
  NAV_PAGE_VISITED = 'nav_page_visited',                // shared navigation page visited
  NAV_PREVIEW_INTENT_STARTED = 'nav_preview_intent_started', // autoplay preview
  NAV_PREVIEW_SKIPPED = 'nav_preview_skipped',          // user clicked skip preview button
  NAV_PREVIEW_STEPS_STARTED = 'nav_steps_started',          // step by step
  NAV_PREVIEW_ENDED = 'nav_preview_ended',                  // reached the end of the preview
  NAV_PAGE_INTERACTED = 'nav_page_interacted',
  EXPLORE_JOYSTICK_INTERACTION = 'explore_joystick_interaction',
  EXPLORE_INTERACTION = 'explore_interaction',
}